/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Whats_NewInputs */

const vi_nav_whats_new = /** @type {(inputs: Nav_Whats_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có gì mới`)
};

/**

* @param {Nav_Whats_NewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_whats_new = /** @type {((inputs?: Nav_Whats_NewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Whats_NewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_whats_new(inputs)
});